import { useEffect, useReducer, useRef, useState } from "react";
import IMask from "imask";
import SettingsIcon from '@mui/icons-material/Settings';
import CloseIcon from '@mui/icons-material/Close'
import {
  Button, Box, Checkbox, Dialog, DialogActions, DialogContent,
  DialogTitle, Divider, FormControlLabel, IconButton,
  TextField,
  Tooltip
} from "@mui/material";
import { lockedReducer } from "../../utils/defaultReducer";
import { ColorPicker } from "../Settings/Labels/AddLabelDialog";
import PaletteIcon from '@mui/icons-material/Palette';

const butonStyles = {
  position: 'absolute',
  width: '107%',
  height: '100%',
  bottom: 0,
  left: 0,
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'flex-start',
}

function getContrastColor(hex) {
  // Remove o # se existir
  hex = hex.replace('#', '');

  // Converte para RGB
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);

  // Calcula luminância perceptiva
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b);

  // Se for claro, retorna preto; se for escuro, retorna branco
  return luminance > 150 ? '#000000' : '#FFFFFF';
}


const RenderEditButton = ({ title, background, paddingTop = '0px', setEdit }) => {

  const [hover, setHover] = useState(false)

  const settingsStyles = { width: '24px', display: hover ? 'block' : 'none', cursor: 'pointer', paddingTop, color: getContrastColor(background || '#ffffff') }

  return (
    <div
      style={butonStyles}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <Tooltip title={title}><SettingsIcon onClick={() => setEdit(true)} style={settingsStyles} /></Tooltip>
    </div>
  )
}

const renderLogo = ({ props, title, parent, setEdit }) => {
  const url = (parent.logo ? URL.createObjectURL(parent.logo) : parent.logo_url)
  if (url)
    return (
      <div className='kwik-form-header' style={{ position: 'relative' }}>
        <img className='kwik-form-logo' src={url} style={props} alt={props.text} />
        <RenderEditButton title={title} setEdit={setEdit} />
      </div>
    )
  return '(Logo) - Logo não carregada.'
}

const renderLabel = ({ props, title, parent, setEdit }) => {
  if (parent.title)
    return (
      <div className='kwik-form-header' style={{ position: 'relative' }}>
        <h1 className='kwik-form-title' style={props}>{parent.title}</h1>
        <RenderEditButton title={title} setEdit={setEdit} />
      </div>
    )
  return '(Título) - Título não carregado'
}

const renderDescription = ({ props, title, parent, setEdit }) => {
  if (parent.description)
    return (
      <div className='kwik-form-header' style={{ position: 'relative', whiteSpace:'pre-line' }}>
        <p className='kwik-form-description' style={props}>{parent.description}</p>
        <RenderEditButton title={title} setEdit={setEdit} />
      </div>
    )
  return '(Descrição) - Descrição não carregada'
}

const renderText = ({ props, title, setEdit }) => {

  const { background, ...otherProps } = props

  return (
    <div className='kwik-field' style={{ position: 'relative' }}>
      <label className='kwik-label' style={otherProps}>
        {props.label || title}
        {props.required && " *"}
      </label>
      <input className='kwik-input' placeholder={props.placeholder} required={props.required} label={props.label || title} style={props} />
      {props.help_text && <small class="kwik-help">{props.help_text}</small>}
      <RenderEditButton title={title} setEdit={setEdit} paddingTop='2rem' />
    </div>
  )
}

const renderTextarea = ({ props, title, setEdit }) => {

  const { background, ...otherProps } = props

  return (
    <div className='kwik-field' style={{ position: 'relative' }}>
      <label className='kwik-label' style={otherProps}>
        {props.label || title}
        {props.required && " *"}
      </label>
      <textarea className='kwik-input' placeholder={props.placeholder} required={props.required} label={props.label || title} style={props} />
      {props.help_text && <small class="kwik-help">{props.help_text}</small>}
      <RenderEditButton title={title} setEdit={setEdit} paddingTop='2rem' />
    </div>
  )
}

const renderFile = ({ props, title, setEdit }) => {

  const { background, ...otherProps } = props

  return (
    <div className='kwik-field' style={{ position: 'relative' }}>
      <label className='kwik-label' style={otherProps}>
        {props.label || title}
        {props.required && " *"}
      </label>
      <input className='kwik-input' type='file' multiple required={props.required} label={props.label || title} style={props} />
      {props.help_text && <small class="kwik-help">{props.help_text}</small>}
      <RenderEditButton title={title} setEdit={setEdit} paddingTop='2rem' />
    </div>
  )
}

const renderSelect = ({ props, title, setEdit }) => {

  const { background, ...otherProps } = props

  return (
    <div className='kwik-field' style={{ position: 'relative' }}>
      <label className='kwik-label' style={otherProps}>
        {props.label || title}
        {props.required && " *"}
      </label>
      <input className='kwik-input' placeholder={props.placeholder} required={props.required} label={props.label || title} style={props} />
      {props.help_text && <small class="kwik-help">{props.help_text}</small>}
      <RenderEditButton setEdit={setEdit} paddingTop='2rem' />
    </div>
  )
}

const renderCustom = ({ props, title, setEdit }) => {

  const { background, ...otherProps } = props

  return (
    <div className='kwik-field' style={{ position: 'relative' }}>
      <label className='kwik-label' style={otherProps}>
        {props.label || title}
        {props.required && " *"}
      </label>
      <input className='kwik-input' placeholder={props.placeholder} required={props.required} label={props.label || title} style={props} />
      {props.help_text && <small class="kwik-help">{props.help_text}</small>}
      <RenderEditButton title={title} setEdit={setEdit} paddingTop='2rem' />
    </div>
  )
}

const renderPhone = ({ props, title, type, setEdit }) => {
  return <MaskedField
    props={props}
    title={title}
    setEdit={setEdit}
    placeholder="(00) 00000-0000"
    type={type}
    mask={{
      mask: [
        { mask: "(00) 0000-0000" },   // 8 dígitos
        { mask: "(00) 00000-0000" }   // 9 dígitos
      ]
    }}
  />
}

const renderCPF = ({ props, title, type, setEdit }) => {
  return <MaskedField
    props={props}
    title={title}
    setEdit={setEdit}
    type={type}
    placeholder="000.000.000-00"
    mask={{
      mask: '000.000.000-00'
    }}
  />
}

const renderCNPJ = ({ props, title, type, setEdit }) => {
  return <MaskedField
    props={props}
    title={title}
    setEdit={setEdit}
    type={type}
    placeholder="AA.AAA.AAA/AAAA-AA"
    mask={{
      mask: "AA.AAA.AAA/AAAA-AA", definitions: { A: /[A-Za-z0-9]/ }
    }}
  />
}

const MaskedField = ({ props, title, type, setEdit, mask, placeholder }) => {
  const inputRef = useRef(null);

  const { background, ...otherProps } = props

  useEffect(() => {
    const maskComponent = IMask(inputRef.current, mask);
    return () => maskComponent.destroy();
  }, []);

  return (
    <div className='kwik-field' style={{ position: 'relative' }}>
      <label className='kwik-label' style={otherProps}>
        {props.label || title}
        {props.required && " *"}
      </label>
      <input ref={inputRef} type={type} placeholder={props.placeholder || placeholder}
        required={props.required} className='kwik-input' label={props.label || title} style={props} />
      {props.help_text && <small class="kwik-help">{props.help_text}</small>}
      <RenderEditButton title={title} setEdit={setEdit} paddingTop='2rem' />
    </div>
  )
}

const renderDate = ({ props, title, setEdit }) => {

  const { background, ...otherProps } = props
  return (
    <div className='kwik-field' style={{ position: 'relative' }}>
      <label className='kwik-label' style={otherProps}>
        {props.label || title}
        {props.required && " *"}
      </label>
      <input className='kwik-input' type='date' label={props.label || title} style={props} />
      {props.help_text && <small class="kwik-help">{props.help_text}</small>}
      <RenderEditButton title={title} setEdit={setEdit} paddingTop='2rem' />
    </div>
  )
}

const renderButton = ({ props, title, setEdit }) => {
  return (
    <button style={{ position: 'relative', ...props }} onClick={(e) => { e.preventDefault() }} className="kwik-button" {...props}>
      {props?.text || title}
      <RenderEditButton title={title} setEdit={setEdit} paddingTop='.5rem' />
    </button>
  )
}

const RenderEdit = ({ title, type, props, setProps, handleClose }) => {
  const [state, setState] = useReducer(lockedReducer, {
    required: false,
    label: '',
    placeholder: '',
    text: '',
    color: '',
    background: '',
    width: '',
    height: '',
    borderRadius: '',
    fontSize: '',
    help_text: '',
    maxWidth: '',
    minWidth: ''
  })

  const [picker, setPicker] = useReducer(lockedReducer, {
    color: false,
    background: false,
    hover: false
  })

  useEffect(() => {
    setState(props)
  }, [])

  // When submitting, updating states before closing modal
  const submit = () => {
    setProps(state)
    handleClose()
  }

  return (
    <>
      <Dialog
        fullWidth
        maxWidth='sm'
        open={true}
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box>Opções do(a) {title}</Box> <IconButton onClick={handleClose}><CloseIcon /></IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: '.5rem' }} >
          {!['logo', 'label', 'button', 'general', 'description'].includes(type) && <FormControlLabel
            control={
              <Checkbox checked={state.required} onChange={({ target }) => setState({ required: target.checked })} />
            }
            label={"Obrigatório"}
          />}
          {!['logo', 'label', 'button', 'general', 'description'].includes(type) &&
            <TextField
              size='small'
              label='Nome do campo'
              value={state.label}
              onChange={({ target }) => setState({ label: target.value })
              }
            />
          }
          {!['logo', 'button', 'label', 'general', 'select', 'custom', 'description', 'file'].includes(type) &&
            <TextField
              size='small'
              label='Placeholder'
              value={state.placeholder}
              onChange={({ target }) => setState({ placeholder: target.value })
              }
            />
          }
          {!['logo'].includes(type) &&
            <>
              <TextField
                size='small'
                label='Cor'
                value={state.color}
                onChange={({ target }) => setState({ color: target.value })}
                InputProps={{
                  sx: { padding: 0 },
                  endAdornment: (
                    <Tooltip title='Seletor de cores'><IconButton onClick={() => setPicker({ color: !picker.color })}><PaletteIcon /></IconButton></Tooltip>
                  )
                }}
              />
              {picker.color && <ColorPicker label='Cor' value={state.color} onChange={(color) => setState({ color: color })} sx={{ marginTop: '0 !important' }} />}
            </>
          }
          {!['logo', 'label', 'description'].includes(type) &&
            <>
              <TextField
                size='small'
                label='Cor de fundo'
                value={state.background}
                onChange={({ target }) => setState({ background: target.value })}
                InputProps={{
                  sx: { padding: 0 },
                  endAdornment: (
                    <Tooltip title='Seletor de cores'><IconButton onClick={() => setPicker({ background: !picker.background })}><PaletteIcon /></IconButton></Tooltip>
                  )
                }}
              />
              {picker.background && <ColorPicker label='Cor' value={state.background} onChange={(color) => setState({ background: color })} sx={{ marginTop: '0 !important' }} />}
            </>
          }
          {['logo', 'title', 'general'].includes(type)
            && <TextField
              size='small'
              label='Largura'
              value={state.width}
              onChange={({ target }) => setState({ width: target.value })}
            />
          }
          {['logo', 'title', 'general'].includes(type)
            && <TextField
              size='small'
              label='Largura Máxima'
              value={state.maxWidth}
              onChange={({ target }) => setState({ maxWidth: target.value })}
            />
          }
          {['logo', 'title', 'general'].includes(type)
            && <TextField
              size='small'
              label='Largura Mínima'
              value={state.minWidth}
              onChange={({ target }) => setState({ minWidth: target.value })}
            />
          }
          {['logo', 'title', 'general'].includes(type)
            && <TextField
              size='small'
              label='Altura'
              value={state.height}
              onChange={({ target }) => setState({ height: target.value })}
            />
          }
          {['logo', 'button', 'general'].includes(type)
            && <TextField
              size='small'
              label='Raio da borda'
              value={state.borderRadius}
              onChange={({ target }) => setState({ borderRadius: target.value })}
            />
          }
          {!['logo'].includes(type)
            && <TextField
              size='small'
              label='Tamanho da fonte'
              value={state.fontSize}
              onChange={({ target }) => setState({ fontSize: target.value })}
            />
          }
          {!['logo', 'label', 'button', 'general', 'description'].includes(type)
            && <TextField
              multiline
              maxRows={4}
              size='small'
              label='Texto de ajuda'
              value={state.help_text}
              onChange={({ target }) => setState({ help_text: target.value })}
              inputProps={{ maxLength: 255 }}
            />
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={submit} >Salvar</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}


export const FieldObject = ({ state, title, type, props, setProps, parent }) => {
  const [edit, setEdit] = useState(false)

  return (
    <>
      {type === 'general' &&
        <Tooltip title={title}>
          <IconButton sx={{ position: 'absolute', top: 0, right: 0, margin:'1.5rem' }} variant='contained' onClick={() => setEdit(true)}>
            <SettingsIcon />
          </IconButton>
        </Tooltip>
      }
      {edit && <RenderEdit title={title} type={type} props={props} setProps={setProps} handleClose={() => setEdit(false)} />}
      {state === 'form' ?
        <>
          {(fieldTypes[type] || (() => { }))({ props, parent, title, type, setEdit }) || title}
        </>
        :
        null
      }
    </>
  )
}

export const fieldTypes = {
  logo: renderLogo,
  label: renderLabel,
  description: renderDescription,
  text: renderText,
  email: renderText,
  telephone: renderPhone,
  date: renderDate,
  button: renderButton,
  cpf: renderCPF,
  cnpj: renderCNPJ,
  select: renderSelect,
  custom: renderCustom,
  textarea: renderTextarea,
  file: renderFile,
}

